var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4435_5813",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.759766,
    width: 19.6,
    height: 19.6,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4435_5813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 -3.14453C-7.34961 -5.04732 -5.80709 -6.58984 -3.9043 -6.58984V-3.14453H-7.34961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 0.300781H-3.9043V3.74609H-7.34961V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 7.19141H-3.9043V10.6367H-7.34961V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 14.082H-3.9043V17.5273H-7.34961V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 20.9727H-3.9043V24.418H-7.34961V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 -3.14453H-0.458984V0.300781H-3.9043V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 3.74609H-0.458984V7.19141H-3.9043V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 10.6367H-0.458984V14.082H-3.9043V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 17.5273H-0.458984V20.9727H-3.9043V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 24.418H-0.458984V27.8633H-3.9043V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 -3.14453H6.43164V0.300781H2.98633V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 3.74609H6.43164V7.19141H2.98633V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 10.6367H6.43164V14.082H2.98633V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 17.5273H6.43164V20.9727H2.98633V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 24.418H6.43164V27.8633H2.98633V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 -3.14453H13.3223V0.300781H9.87695V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 3.74609H13.3223V7.19141H9.87695V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 10.6367H13.3223V14.082H9.87695V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 17.5273H13.3223V20.9727H9.87695V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 24.418H13.3223V27.8633H9.87695V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 -3.14453H20.2129V0.300781H16.7676V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 3.74609H20.2129V7.19141H16.7676V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 10.6367H20.2129V14.082H16.7676V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 17.5273H20.2129V20.9727H16.7676V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 24.418H20.2129V27.8633H16.7676V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 -3.14453H27.1035V0.300781H23.6582V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 3.74609H27.1035V7.19141H23.6582V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 10.6367H27.1035V14.082H23.6582V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 17.5273H27.1035V20.9727H23.6582V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 24.418H27.1035C27.1035 26.3208 25.561 27.8633 23.6582 27.8633V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 -6.58984H2.98633V-3.14453H-0.458984V-6.58984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 0.300781H2.98633V3.74609H-0.458984V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 7.19141H2.98633V10.6367H-0.458984V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 14.082H2.98633V17.5273H-0.458984V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 20.9727H2.98633V24.418H-0.458984V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 -6.58984H9.87695V-3.14453H6.43164V-6.58984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 0.300781H9.87695V3.74609H6.43164V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 7.19141H9.87695V10.6367H6.43164V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 14.082H9.87695V17.5273H6.43164V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 20.9727H9.87695V24.418H6.43164V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 -6.58984H16.7676V-3.14453H13.3223V-6.58984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 0.300781H16.7676V3.74609H13.3223V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 7.19141H16.7676V10.6367H13.3223V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 14.082H16.7676V17.5273H13.3223V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 20.9727H16.7676V24.418H13.3223V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 -6.58984H23.6582V-3.14453H20.2129V-6.58984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 0.300781H23.6582V3.74609H20.2129V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 7.19141H23.6582V10.6367H20.2129V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 14.082H23.6582V17.5273H20.2129V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 20.9727H23.6582V24.418H20.2129V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 -6.58984H-0.458984V-3.14453H-3.9043V-6.58984Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 0.300781H-0.458984V3.74609H-3.9043V0.300781Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 7.19141H-0.458984V10.6367H-3.9043V7.19141Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 14.082H-0.458984V17.5273H-3.9043V14.082Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9043 20.9727H-0.458984V24.418H-3.9043V20.9727Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 -3.14453H-3.9043V0.300781H-7.34961V-3.14453Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 3.74609H-3.9043V7.19141H-7.34961V3.74609Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 10.6367H-3.9043V14.082H-7.34961V10.6367Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 17.5273H-3.9043V20.9727H-7.34961V17.5273Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.34961 24.418H-3.9043V27.8633C-5.80709 27.8633 -7.34961 26.3208 -7.34961 24.418Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 -3.14453H2.98633V0.300781H-0.458984V-3.14453Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 3.74609H2.98633V7.19141H-0.458984V3.74609Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 10.6367H2.98633V14.082H-0.458984V10.6367Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 17.5273H2.98633V20.9727H-0.458984V17.5273Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.458984 24.418H2.98633V27.8633H-0.458984V24.418Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 -3.14453H9.87695V0.300781H6.43164V-3.14453Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 3.74609H9.87695V7.19141H6.43164V3.74609Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 10.6367H9.87695V14.082H6.43164V10.6367Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 17.5273H9.87695V20.9727H6.43164V17.5273Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43164 24.418H9.87695V27.8633H6.43164V24.418Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 -3.14453H16.7676V0.300781H13.3223V-3.14453Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 3.74609H16.7676V7.19141H13.3223V3.74609Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 10.6367H16.7676V14.082H13.3223V10.6367Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 17.5273H16.7676V20.9727H13.3223V17.5273Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3223 24.418H16.7676V27.8633H13.3223V24.418Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 -3.14453H23.6582V0.300781H20.2129V-3.14453Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 3.74609H23.6582V7.19141H20.2129V3.74609Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 10.6367H23.6582V14.082H20.2129V10.6367Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 17.5273H23.6582V20.9727H20.2129V17.5273Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 24.418H23.6582V27.8633H20.2129V24.418Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 -6.58984H6.43164V-3.14453H2.98633V-6.58984Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 0.300781H6.43164V3.74609H2.98633V0.300781Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 7.19141H6.43164V10.6367H2.98633V7.19141Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 14.082H6.43164V17.5273H2.98633V14.082Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 20.9727H6.43164V24.418H2.98633V20.9727Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 -6.58984H13.3223V-3.14453H9.87695V-6.58984Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 0.300781H13.3223V3.74609H9.87695V0.300781Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 7.19141H13.3223V10.6367H9.87695V7.19141Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 14.082H13.3223V17.5273H9.87695V14.082Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 20.9727H13.3223V24.418H9.87695V20.9727Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 -6.58984H20.2129V-3.14453H16.7676V-6.58984Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 0.300781H20.2129V3.74609H16.7676V0.300781Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 7.19141H20.2129V10.6367H16.7676V7.19141Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 14.082H20.2129V17.5273H16.7676V14.082Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7676 20.9727H20.2129V24.418H16.7676V20.9727Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 -6.58984C25.561 -6.58984 27.1035 -5.04732 27.1035 -3.14453H23.6582V-6.58984Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 0.300781H27.1035V3.74609H23.6582V0.300781Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 7.19141H27.1035V10.6367H23.6582V7.19141Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 14.082H27.1035V17.5273H23.6582V14.082Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 20.9727H27.1035V24.418H23.6582V20.9727Z",
    fill: "#C3C3C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparent);
export default __webpack_public_path__ + "static/media/transparent.3d1538b54e3615abecaf833d647fa7bb.svg";
export { ForwardRef as ReactComponent };